import type { SvgIconComponent } from "@mui/icons-material";
import AccountBalance from "@mui/icons-material/AccountBalanceOutlined";
import AccountBalanceWallet from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountCircle from "@mui/icons-material/AccountCircleOutlined";
import AccountTree from "@mui/icons-material/AccountTreeOutlined";
import AddChart from "@mui/icons-material/AddchartOutlined";
import AdminPanelSettings from "@mui/icons-material/AdminPanelSettingsOutlined";
import Alarm from "@mui/icons-material/AlarmOutlined";
import Analytics from "@mui/icons-material/AnalyticsOutlined";
import Announcement from "@mui/icons-material/AnnouncementOutlined";
import Apartment from "@mui/icons-material/ApartmentOutlined";
import Archive from "@mui/icons-material/ArchiveOutlined";
import Article from "@mui/icons-material/ArticleOutlined";
import Assessment from "@mui/icons-material/AssessmentOutlined";
import AssignmentInd from "@mui/icons-material/AssignmentIndOutlined";
import AssignmentLate from "@mui/icons-material/AssignmentLateOutlined";
import Assignment from "@mui/icons-material/AssignmentOutlined";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedInOutlined";
import AttachFile from "@mui/icons-material/AttachFileOutlined";
import AttachMoney from "@mui/icons-material/AttachMoneyOutlined";
import Badge from "@mui/icons-material/BadgeOutlined";
import Balance from "@mui/icons-material/BalanceOutlined";
import Ballot from "@mui/icons-material/BallotOutlined";
import BarChart from "@mui/icons-material/BarChartOutlined";
import Block from "@mui/icons-material/BlockOutlined";
import Bookmark from "@mui/icons-material/BookmarkOutlined";
import Bookmarks from "@mui/icons-material/BookmarksOutlined";
import Business from "@mui/icons-material/BusinessOutlined";
import Calculate from "@mui/icons-material/CalculateOutlined";
import CalendarToday from "@mui/icons-material/CalendarTodayOutlined";
import Campaign from "@mui/icons-material/CampaignOutlined";
import Cancel from "@mui/icons-material/CancelOutlined";
import CardMembership from "@mui/icons-material/CardMembershipOutlined";
import Cases from "@mui/icons-material/CasesOutlined";
import Category from "@mui/icons-material/CategoryOutlined";
import Chat from "@mui/icons-material/ChatOutlined";
import CheckCircle from "@mui/icons-material/CheckCircleOutlined";
import Checklist from "@mui/icons-material/ChecklistOutlined";
import CollectionsBookmark from "@mui/icons-material/CollectionsBookmarkOutlined";
import CompareArrows from "@mui/icons-material/CompareArrowsOutlined";
import ConnectWithoutContact from "@mui/icons-material/ConnectWithoutContactOutlined";
import ContactPage from "@mui/icons-material/ContactPageOutlined";
import Contacts from "@mui/icons-material/ContactsOutlined";
import CorporateFare from "@mui/icons-material/CorporateFareOutlined";
import CreateNewFolder from "@mui/icons-material/CreateNewFolderOutlined";
import CreditCard from "@mui/icons-material/CreditCardOutlined";
import CurrencyExchange from "@mui/icons-material/CurrencyExchangeOutlined";
import Dashboard from "@mui/icons-material/DashboardOutlined";
import DateRange from "@mui/icons-material/DateRangeOutlined";
import Diversity3 from "@mui/icons-material/Diversity3Outlined";
import DocumentScanner from "@mui/icons-material/DocumentScannerOutlined";
import DoneAll from "@mui/icons-material/DoneAllOutlined";
import DonutLarge from "@mui/icons-material/DonutLargeOutlined";
import Drafts from "@mui/icons-material/DraftsOutlined";
import Email from "@mui/icons-material/EmailOutlined";
import EventAvailable from "@mui/icons-material/EventAvailableOutlined";
import EventNote from "@mui/icons-material/EventNoteOutlined";
import Event from "@mui/icons-material/EventOutlined";
import FactCheck from "@mui/icons-material/FactCheckOutlined";
import Factory from "@mui/icons-material/FactoryOutlined";
import Feedback from "@mui/icons-material/FeedbackOutlined";
import FileCopy from "@mui/icons-material/FileCopyOutlined";
import FileDownload from "@mui/icons-material/FileDownloadOutlined";
import FilePresent from "@mui/icons-material/FilePresentOutlined";
import FileUpload from "@mui/icons-material/FileUploadOutlined";
import Flag from "@mui/icons-material/FlagOutlined";
import FolderCopy from "@mui/icons-material/FolderCopyOutlined";
import Folder from "@mui/icons-material/FolderOutlined";
import FolderShared from "@mui/icons-material/FolderSharedOutlined";
import FolderSpecial from "@mui/icons-material/FolderSpecialOutlined";
import Forum from "@mui/icons-material/ForumOutlined";
import Gavel from "@mui/icons-material/GavelOutlined";
import Grading from "@mui/icons-material/GradingOutlined";
import GridView from "@mui/icons-material/GridViewOutlined";
import GroupAdd from "@mui/icons-material/GroupAddOutlined";
import Groups from "@mui/icons-material/GroupsOutlined";
import Handshake from "@mui/icons-material/HandshakeOutlined";
import Help from "@mui/icons-material/HelpOutlined";
import History from "@mui/icons-material/HistoryOutlined";
import Home from "@mui/icons-material/HomeOutlined";
import HomeWork from "@mui/icons-material/HomeWorkOutlined";
import HourglassEmpty from "@mui/icons-material/HourglassEmptyOutlined";
import ImportExport from "@mui/icons-material/ImportExportOutlined";
import Inbox from "@mui/icons-material/InboxOutlined";
import Info from "@mui/icons-material/InfoOutlined";
import InsertDriveFile from "@mui/icons-material/InsertDriveFileOutlined";
import Insights from "@mui/icons-material/InsightsOutlined";
import Inventory2 from "@mui/icons-material/Inventory2Outlined";
import Key from "@mui/icons-material/KeyOutlined";
import LabelImportant from "@mui/icons-material/LabelImportantOutlined";
import Layers from "@mui/icons-material/LayersOutlined";
import Leaderboard from "@mui/icons-material/LeaderboardOutlined";
import Link from "@mui/icons-material/LinkOutlined";
import LiveHelp from "@mui/icons-material/LiveHelpOutlined";
import LocalOffer from "@mui/icons-material/LocalOfferOutlined";
import LocationCity from "@mui/icons-material/LocationCityOutlined";
import LockOpen from "@mui/icons-material/LockOpenOutlined";
import Lock from "@mui/icons-material/LockOutlined";
import ManageAccounts from "@mui/icons-material/ManageAccountsOutlined";
import MarkEmailRead from "@mui/icons-material/MarkEmailReadOutlined";
import MarkEmailUnread from "@mui/icons-material/MarkEmailUnreadOutlined";
import MenuBook from "@mui/icons-material/MenuBookOutlined";
import Money from "@mui/icons-material/MoneyOutlined";
import MultilineChart from "@mui/icons-material/MultilineChartOutlined";
import NewReleases from "@mui/icons-material/NewReleasesOutlined";
import Newspaper from "@mui/icons-material/NewspaperOutlined";
import Notes from "@mui/icons-material/NotesOutlined";
import Notifications from "@mui/icons-material/NotificationsOutlined";
import Outbox from "@mui/icons-material/OutboxOutlined";
import Paid from "@mui/icons-material/PaidOutlined";
import Payments from "@mui/icons-material/PaymentsOutlined";
import PendingActions from "@mui/icons-material/PendingActionsOutlined";
import People from "@mui/icons-material/PeopleOutlined";
import PersonAdd from "@mui/icons-material/PersonAddOutlined";
import Person from "@mui/icons-material/PersonOutlined";
import PieChart from "@mui/icons-material/PieChartOutlined";
import PlaylistAddCheck from "@mui/icons-material/PlaylistAddCheckOutlined";
import Policy from "@mui/icons-material/PolicyOutlined";
import PriceCheck from "@mui/icons-material/PriceCheckOutlined";
import Public from "@mui/icons-material/PublicOutlined";
import PushPin from "@mui/icons-material/PushPinOutlined";
import QueryStats from "@mui/icons-material/QueryStatsOutlined";
import Receipt from "@mui/icons-material/ReceiptOutlined";
import RecentActors from "@mui/icons-material/RecentActorsOutlined";
import RequestQuote from "@mui/icons-material/RequestQuoteOutlined";
import RuleFolder from "@mui/icons-material/RuleFolderOutlined";
import Rule from "@mui/icons-material/RuleOutlined";
import Schedule from "@mui/icons-material/ScheduleOutlined";
import Security from "@mui/icons-material/SecurityOutlined";
import Sell from "@mui/icons-material/SellOutlined";
import Send from "@mui/icons-material/SendOutlined";
import Settings from "@mui/icons-material/SettingsOutlined";
import Share from "@mui/icons-material/ShareOutlined";
import Shield from "@mui/icons-material/ShieldOutlined";
import ShowChart from "@mui/icons-material/ShowChartOutlined";
import SnippetFolder from "@mui/icons-material/SnippetFolderOutlined";
import StackedLineChart from "@mui/icons-material/StackedLineChartOutlined";
import Star from "@mui/icons-material/StarOutlined";
import StickyNote2 from "@mui/icons-material/StickyNote2Outlined";
import Store from "@mui/icons-material/StoreOutlined";
import Summarize from "@mui/icons-material/SummarizeOutlined";
import SupervisorAccount from "@mui/icons-material/SupervisorAccountOutlined";
import SupportAgent from "@mui/icons-material/SupportAgentOutlined";
import TableChart from "@mui/icons-material/TableChartOutlined";
import TaskAlt from "@mui/icons-material/TaskAltOutlined";
import Task from "@mui/icons-material/TaskOutlined";
import TextSnippet from "@mui/icons-material/TextSnippetOutlined";
import Timeline from "@mui/icons-material/TimelineOutlined";
import Timer from "@mui/icons-material/TimerOutlined";
import Topic from "@mui/icons-material/TopicOutlined";
import TrendingDown from "@mui/icons-material/TrendingDownOutlined";
import TrendingUp from "@mui/icons-material/TrendingUpOutlined";
import Update from "@mui/icons-material/UpdateOutlined";
import UploadFile from "@mui/icons-material/UploadFileOutlined";
import Verified from "@mui/icons-material/VerifiedOutlined";
import VerifiedUser from "@mui/icons-material/VerifiedUserOutlined";
import ViewList from "@mui/icons-material/ViewListOutlined";
import ViewTimeline from "@mui/icons-material/ViewTimelineOutlined";
import Wallet from "@mui/icons-material/WalletOutlined";
import Warehouse from "@mui/icons-material/WarehouseOutlined";
import Warning from "@mui/icons-material/WarningOutlined";
import WorkHistory from "@mui/icons-material/WorkHistoryOutlined";
import Work from "@mui/icons-material/WorkOutlined";

export const materialIconPrefix = "MUI_";

export const categoryIcons: Record<string, SvgIconComponent> = {
  Ballot,
  Article,
  TextSnippet,
  Notes,
  StickyNote2,
  Newspaper,
  Folder,
  FolderShared,
  FolderSpecial,
  CreateNewFolder,
  Topic,
  Inventory2,
  InsertDriveFile,
  FilePresent,
  AttachFile,
  UploadFile,
  FileDownload,
  FileUpload,
  FileCopy,
  Summarize,
  Assignment,
  AssignmentTurnedIn,
  AssignmentInd,
  AssignmentLate,
  Assessment,
  Analytics,
  MenuBook,
  Grading,
  Bookmarks,
  CollectionsBookmark,
  DocumentScanner,
  AccountBalance,
  AccountBalanceWallet,
  Payments,
  Paid,
  PriceCheck,
  RequestQuote,
  Receipt,
  AttachMoney,
  CurrencyExchange,
  Calculate,
  Money,
  CreditCard,
  Wallet,
  TrendingUp,
  TrendingDown,
  ShowChart,
  StackedLineChart,
  BarChart,
  PieChart,
  DonutLarge,
  Insights,
  QueryStats,
  Leaderboard,
  Timeline,
  MultilineChart,
  AddChart,
  SnippetFolder,
  Business,
  FolderCopy,
  Apartment,
  Layers,
  CorporateFare,
  Store,
  Warehouse,
  Factory,
  Work,
  WorkHistory,
  Badge,
  CardMembership,
  Cases,
  HomeWork,
  AccountTree,
  Gavel,
  Balance,
  Policy,
  VerifiedUser,
  Verified,
  Shield,
  Security,
  AdminPanelSettings,
  Rule,
  RuleFolder,
  FactCheck,
  PlaylistAddCheck,
  Checklist,
  TaskAlt,
  Task,
  DoneAll,
  Lock,
  LockOpen,
  Key,
  Person,
  People,
  Groups,
  SupervisorAccount,
  ManageAccounts,
  AccountCircle,
  PersonAdd,
  GroupAdd,
  Diversity3,
  Handshake,
  ConnectWithoutContact,
  Contacts,
  ContactPage,
  RecentActors,
  Email,
  MarkEmailRead,
  MarkEmailUnread,
  Drafts,
  Outbox,
  Send,
  Forum,
  Chat,
  Announcement,
  Campaign,
  Notifications,
  Feedback,
  TableChart,
  SupportAgent,
  LiveHelp,
  ViewTimeline,
  CalendarToday,
  DateRange,
  EventNote,
  Event,
  EventAvailable,
  Schedule,
  Update,
  History,
  Alarm,
  Timer,
  HourglassEmpty,
  PendingActions,
  Flag,
  LabelImportant,
  Bookmark,
  Star,
  PushPin,
  LocalOffer,
  Sell,
  NewReleases,
  Info,
  Help,
  Warning,
  CheckCircle,
  Cancel,
  Block,
  Home,
  LocationCity,
  Public,
  Settings,
  Category,
  Dashboard,
  GridView,
  ViewList,
  CompareArrows,
  ImportExport,
  Archive,
  Inbox,
  Share,
  Link,
};
